"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * It's a button. Doesn't get simpler than this.
 */
function Button(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'tertiary-1' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["variant", "size", "isLoading", "type", "children"]);

  // TODO: use chakra's useToken() to get tokens for gradient
  var background;
  var textColor;
  var fontSize;
  var height;
  var border;
  var borderWidth = 0;
  var paddingX;
  var activeStyles;
  var hoverStyles;
  var focusStyles = {
    textDecoration: variant.includes('tertiary') ? 'underline' : 'none'
  };
  var disabledStyles = {
    background: 'gray.300',
    color: 'gray.0',
    cursor: 'not-allowed'
  };

  if (size === 'large') {
    fontSize = 'md';
    height = '14';
    paddingX = "".concat((23.5 - borderWidth) / 16, "rem");
  } else if (size === 'medium') {
    fontSize = 'sm';
    height = '12';
    paddingX = "".concat((23.5 - borderWidth) / 16, "rem");
  } else if (size === 'small') {
    fontSize = 'xs';
    height = '10';
    paddingX = "".concat((19.5 - borderWidth) / 16, "rem");
  }

  if (variant.includes('tertiary')) {
    height = 'auto';
    paddingX = '0';
  }

  switch (variant) {
    case 'primary-1':
      background = 'linear-gradient(135deg,#E9425B,#CF1F2E)';
      textColor = 'white';
      activeStyles = {
        background: background
      };
      hoverStyles = {
        background: 'linear-gradient(135deg,#C31C35,#A90008)'
      };
      break;

    case 'primary-2':
      background = '#1B1B1B';
      textColor = 'white';
      activeStyles = {
        background: background
      };
      hoverStyles = {
        background: '#1B1B1BBF'
      };
      break;

    case 'secondary-1':
      background = 'transparent';
      textColor = '#CF1F2E';
      border = '2px solid #CF1F2E';
      activeStyles = {
        background: background
      };
      hoverStyles = {
        background: '#D11F2E12'
      };
      borderWidth = 2;
      break;

    case 'secondary-2':
      background = 'transparent';
      textColor = '#2E2E2E';
      border = '2px solid #1B1B1B';
      activeStyles = {
        background: background
      };
      hoverStyles = {
        background: '#1B1B1B1A'
      };
      borderWidth = 2;
      break;

    case 'tertiary-1':
      textColor = '#2E2E2E';
      hoverStyles = {
        textDecoration: 'underline'
      };
      break;

    case 'tertiary-2':
      textColor = '#EB003B';
      hoverStyles = {
        textDecoration: 'underline'
      };
      break;

    case 'tertiary-3':
      textColor = '#0475BC';
      hoverStyles = {
        textDecoration: 'underline'
      };
      break;

    default:
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react2.Box, _objectSpread(_objectSpread({
    as: "button",
    type: type,
    paddingX: paddingX,
    fontSize: fontSize,
    height: height,
    borderRadius: variant.includes('tertiary') ? '0' : 'full',
    border: border,
    background: background,
    color: textColor,
    fontWeight: "bold",
    _hover: hoverStyles,
    _active: activeStyles,
    _focus: focusStyles,
    _disabled: disabledStyles,
    disabled: isLoading,
    position: "relative"
  }, rest), {}, {
    children: [isLoading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Box, {
      position: "absolute",
      top: "58%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Spinner, {
        emptyColor: "gray.400",
        size: "sm"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Flex, {
      alignItems: "center",
      justifyContent: "center",
      visibility: isLoading ? 'hidden' : 'visible',
      children: children
    })]
  }));
}

Button.propTypes = {
  variant: _propTypes.default.oneOf(['primary-1', 'primary-2', 'secondary-1', 'secondary-2', 'tertiary-1', 'tertiary-2', 'tertiary-3']).isRequired,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  type: _propTypes.default.oneOf(['button', 'submit', 'reset']),
  isLoading: _propTypes.default.bool,

  /**
   * Can be text or html element.
   */
  children: _propTypes.default.node.isRequired
};
var _default = Button;
exports.default = _default;

//# sourceMappingURL=Button.jsx.map